export const FIRMFLOWURL =
  process.env.REACT_APP_API_ENDPOINT || "https://firmflow-api-iu9dj.ondigitalocean.app/";
